"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var hyphenate_1 = require("./hyphenate");
var msPattern = /^ms-/;
function hyphenateStyle(s) {
    return hyphenate_1.hyphenate(s).replace(msPattern, '-ms-');
}
exports.hyphenateStyle = hyphenateStyle;
